import { render, staticRenderFns } from "./SidebarButton.vue?vue&type=template&id=19b57b8e&scoped=true&"
import script from "./SidebarButton.vue?vue&type=script&lang=js&"
export * from "./SidebarButton.vue?vue&type=script&lang=js&"
import style0 from "./SidebarButton.vue?vue&type=style&index=0&id=19b57b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b57b8e",
  null
  
)

export default component.exports